// extracted by mini-css-extract-plugin
module.exports = {"root":"FrontImage_root__1jkUB","title":"FrontImage_title__2shq-"};